import { useEffect, useState } from 'react';
import { IOption } from 'interfaces';

import { equipmentApi } from '../api';
import { EquipmentLinkMode } from '../types';

export const useEquipmentCostLinkOptions = (mode: EquipmentLinkMode) => {
  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    equipmentApi.getLinkOptions(mode).then(setOptions);
  }, [mode]);

  return { options };
};
